import * as Sentry from "@sentry/nextjs";
import { getEnv } from "./env";

export const initializeSentry = () => {
  // Prevent logging errors to sentry during development and tests
  // https://create-react-app.dev/docs/adding-custom-environment-variables/
  try {
    if (!["development", "test"].includes(getEnv("NODE_ENV"))) {
      Sentry.init({
        dsn: getEnv("NEXT_PUBLIC_SENTRY_DSN"),
        tunnel: `${getEnv("NEXT_PUBLIC_API_URL")}/tunnel`,
        environment: getEnv("NEXT_PUBLIC_ENV") || "unknown",
        tracesSampleRate: 1.0,
      });
    }
  } catch (e) {}
};
